const qualifiers = [
  "You know what you want but keep losing momentum.",
  "You\u2019re tired of making beautiful plans that disappear beneath everyday life.",
  "You want accountability without shame, pressure or performative productivity.",
  "You don\u2019t need someone to tell you what your dream should be.",
  "You need somewhere that helps you stay in relationship with it.",
  "You want to be supported by people who understand that progress can be quiet and still be real.",
];

export function ThisMayBeForYou() {
  return (
    <section data-testid="cc-may-be-for-you-section" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[56px] md:pt-[76px] pb-[56px] md:pb-[76px] reveal">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-display text-4xl md:text-5xl lg:text-[54px] leading-[1.1] tracking-tight text-[#1C1917] mb-10">
            You may belong here if&hellip;
          </h2>

          <div className="space-y-5 text-left max-w-xl mx-auto">
            {qualifiers.map((q, i) => (
              <p
                key={q}
                data-testid={`cc-qualifier-${i}`}
                className="text-lg md:text-xl leading-relaxed text-[#57534E]"
              >
                {q}
              </p>
            ))}
          </div>

          <div className="mt-12 space-y-1">
            <p className="font-display text-2xl md:text-3xl text-[#57534E] leading-snug">
              You don&rsquo;t have to arrive certain.
            </p>
            <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug">
              You only have to arrive willing to return.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
